import { getIt } from "@uikit/getIt";
import React, { useEffect } from "react";
import { ReactFlowProvider } from "reactflow";
import { matchMobile } from "@uikit/func";
import { Cot } from "@uiview/pages/mobile/COT/Cot";
import { HomeUsePluginRootV2 } from "@views/thinking-layout-editor/HomeUsePluginV2";
import { HomeStore } from "imagica-corekit/dist/cases/store/HomeStore";
import { useStore } from "imagica-uikit/dist/hooks/useStore";
import { LottieAnimation } from "@views/components/LottieAnimation";
import { showNavPageStore } from "@uiview/views/HomeRoot/store/ShowNavPageStore";
import { useParams } from "react-router-dom";
import { isEmpty } from "lodash";

export type EditorProps = {
  page?: string;
  share?: boolean;
};

export function Editor(props: EditorProps): React.ReactNode {
  const homeStore = getIt(HomeStore);
  const homeStoreState = useStore(homeStore).value;
  const feature_tags = homeStoreState.featureTags;

  const isMobile = matchMobile();
  const urlParam = useParams();

  // update showNavPageStore default state
  useEffect(() => {
    showNavPageStore.setDefaultState(isEmpty(urlParam.attrIndexer));
  }, []);

  if (isMobile && feature_tags.disableMobilePage === false && props.share !== true) {
    return <Cot />;
  }

  return (
    <ReactFlowProvider>
      {/* STUD-2195: 预加载一次，为了修复cot unsupport弹窗和onboarding弹窗，首次显示时动画没有播放 */}
      <LottieAnimation loader={null} />
      <HomeUsePluginRootV2 {...props} />
    </ReactFlowProvider>
  );
}
